import { API_URL, resolveWebAdminApiBaseUrl } from './http/core';

export function buildAuthorizedFileUrlWithBase(url: string, base?: string): string {
  if (!url || typeof window === 'undefined') return url;
  const apiBase = (base || resolveWebAdminApiBaseUrl()).replace(/\/$/, '');
  try {
    const parsed = new URL(url.trim(), apiBase);
    if (!parsed.pathname.includes('/api/v1/files/')) {
      return url;
    }
    const canonical = new URL(parsed.pathname + parsed.search, apiBase);
    canonical.searchParams.delete('token');
    return canonical.toString();
  } catch {
    return url;
  }
}

/**
 * Превью вложений чата: пути `/api/v1/files/...` резолвятся от origin API,
 * иначе `<img src>` на другом домене уйдёт на фронт и даст 404.
 */
export function buildChatAttachmentPreviewUrl(
  fileUrl?: string | null,
  thumbnailUrl?: string | null
): string {
  const raw = (thumbnailUrl || fileUrl || '').trim();
  if (!raw || typeof window === 'undefined') return '';
  const base = resolveWebAdminApiBaseUrl();
  try {
    const absolute =
      raw.startsWith('http://') || raw.startsWith('https://')
        ? raw
        : new URL(raw.startsWith('/') ? raw : `/${raw}`, base).toString();
    return buildAuthorizedFileUrlWithBase(absolute, base);
  } catch {
    return buildAuthorizedFileUrlWithBase(raw, base);
  }
}

export function fileUrlWithAccessToken(path: string | null | undefined): string | null {
  if (!path) return null;
  const base = API_URL.replace(/\/$/, '');
  try {
    const u = new URL(path.trim(), base);
    if (!u.pathname.includes('/api/v1/files/')) {
      const full =
        path.startsWith('http://') || path.startsWith('https://')
          ? path
          : `${base}${path.startsWith('/') ? path : `/${path}`}`;
      return full;
    }
    const canonical = new URL(u.pathname + u.search, base);
    canonical.searchParams.delete('token');
    return canonical.toString();
  } catch {
    return path;
  }
}
